import { Box, Button } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { GqlPlannerVisitStatus } from "~/__generated__";

import { ConfirmRejectDialog } from "./ConfirmRejectDialog";
import { ProjectReviewVisitV2RejectButtonFragment } from "./fragments.generated";

type Props = {
    onReject: (rejectionReason: string) => Promise<void>;
    loading?: boolean;
    visit: ProjectReviewVisitV2RejectButtonFragment;
};

export function ProjectReviewVisitV2RejectButton({ visit, onReject, loading = false }: Props) {
    const { t } = useTranslation("project");
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleConfirm = async (rejectionReason: string) => {
        await onReject(rejectionReason);
        setDialogOpen(false);
    };

    if (visit.status === GqlPlannerVisitStatus.Approved) {
        return null;
    }

    return (
        <Box padding={2}>
            <Button variant="outlined" color="error" fullWidth onClick={() => setDialogOpen(true)} disabled={loading}>
                {t("projectReviewVisitV2.rejectButton.rejectAndReplan")}
            </Button>

            <ConfirmRejectDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                onConfirm={handleConfirm}
                loading={loading}
            />
        </Box>
    );
}
